import React, { useState, useEffect } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { AiFillUnlock } from "react-icons/ai";
import { MdOutlineClose } from "react-icons/md";
import { DatePicker, Form } from 'antd';
import 'moment/locale/ru';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/ru_RU';
import { isEmpty } from 'lodash';

import classes from './CreatePasswordViaHash.module.scss';

import axios from '../../../../../services/axios'
import { setMessage } from '../../../../../store/actions/message';
import { useQuery } from '../../../../../services/useQueryHook';

import PasswordRecoveryWrapper from '../../PasswordRecoveryWrapper';
import SubmitButton from '../../../../UI/SubmitButton/SubmitButton';
import { CreateConfirmPasswordComponent } from '../../../../UI/CreateConfirmPassword/CreateConfirmPassword';
import UnderlinedLink from '../../../../UI/UnderlinedLink/UnderlinedLink';

const CreatePasswordViaHash = () => {
    const query = useQuery()
    const dispatch = useDispatch()
    const routerHistory = useHistory()
    const routerLocation = useLocation()

    const [ifUnmount, setIfUnmount] = useState(false)

    const [linkParamsState, setLinkParamsState] = useState(null)
    const [linkLifetimeState, setLinkLifetimeState] = useState(null)
    const [birthDate, setBirthDate] = useState(null)
    const [hash, setHash] = useState('')
    const [hashExpireTime, setHashExpireTime] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmedPassword, setConfirmedPassword] = useState('')
    const [createPasswordLoading, setCreatePasswordLoading] = useState(false)

    useEffect(() => {
        if (isEmpty(query) && !query.get('t') && !query.get('h')) setLinkParamsState(false)
        else {
            setLinkParamsState(true)
            setHash(query.get('h'))
            setHashExpireTime(query.get('t'))
            if (moment().valueOf() >= parseInt(query.get('t')))
                setLinkLifetimeState(false)
            else setLinkLifetimeState(true)
        }
    }, [query])

    const setContainerStylesOnUnmount = () => {
        if (ifUnmount) return { opacity: 0, transform: 'translateY(20px)' }
        else return { opacity: 1, transform: 'translateY(0)' }
    }

    const createPasswordViaHashRequest = () => {
        setCreatePasswordLoading(true)
        axios.post('/api/v1/settings/password/new-by-hash', {
            hash: hash,
            birthDate: birthDate.format('YYYY-MM-DD'),
            password: newPassword,
            expiredTime: hashExpireTime,
        })
            .then(() => {
                setCreatePasswordLoading(false)
                setIfUnmount(true)
                routerHistory.replace({ pathname: '/password-recovery/success', state: { prevPath: routerLocation.pathname } })
            })
            .catch(() => {
                setCreatePasswordLoading(false)
                dispatch(setMessage({ type: 'error', text: "Не удалось создать новый пароль." }))
            })
    }

    return (
        <React.Fragment>
            {(linkParamsState === false) && <Redirect to="/" />}
            {(linkParamsState === true && linkLifetimeState !== null) &&
                <PasswordRecoveryWrapper
                    icon={linkLifetimeState !== false ? <AiFillUnlock size={35} /> : <MdOutlineClose size={45} />}
                    title={linkLifetimeState !== false ? "Создание нового пароля" : "Срок действия ссылки истек!"}
                    color={linkLifetimeState !== false ? "#3A547F" : "#f44336"}
                    minHeight={linkLifetimeState !== false ? "415px" : "250px"}
                    showFooter={linkLifetimeState}>
                    <div className={`${classes.container} NewPassword_container_color`} style={setContainerStylesOnUnmount()}>
                        {(linkLifetimeState === true) &&
                            <Form
                                name="new_password"
                                scrollToFirstError={true}
                                labelCol={{ span: 7 }}
                                labelAlign="left"
                                labelWrap
                                colon={false}
                                onFinish={createPasswordViaHashRequest}>

                                {<CreateConfirmPasswordComponent
                                    newPassword={newPassword}
                                    confirmedPassword={confirmedPassword}
                                    setNewPassword={(e) => setNewPassword(e.target.value.trim())}
                                    setConfirmedPassword={(e) => setConfirmedPassword(e.target.value.trim())} />}

                                <Form.Item
                                    name="birthDatePicker"
                                    label="Дата рождения"
                                    rules={[{ required: true, message: 'Данное поле является обязательным!' }]}>
                                    <DatePicker
                                        placeholder='Дата рождения'
                                        locale={locale}
                                        disabledDate={current => current > moment()}
                                        defaultPickerValue={moment().set('year', moment().year() - 17)}
                                        format={[
                                            'DD.MM.YYYY', 'D.MM.YYYY', 'DD.M.YYYY', 'D.M.YYYY',
                                            'DD/MM/YYYY', 'D/MM/YYYY', 'DD/M/YYYY', 'D/M/YYYY',
                                            'DD-MM-YYYY', 'D-MM-YYYY', 'DD-M-YYYY', 'D-M-YYYY',
                                            'DD MM YYYY', 'D MM YYYY', 'DD M YYYY', 'D M YYYY'
                                        ]}
                                        value={birthDate}
                                        onChange={(dateMoment) => setBirthDate(dateMoment)} />
                                </Form.Item>

                                <Form.Item>
                                    <SubmitButton
                                        type="submit"
                                        text="Создать"
                                        block
                                        loading={createPasswordLoading}
                                    />
                                </Form.Item>
                            </Form>}
                        {(linkLifetimeState === false) &&
                            <div className={classes.errorMessageContainer}>
                                <UnderlinedLink routing href="/password-recovery" text="Установить пароль" />
                            </div>
                        }
                    </div>
                </PasswordRecoveryWrapper>}
        </React.Fragment>
    )
}

export default CreatePasswordViaHash